<template>
  <div class="demo-data-browser">
    <div class="background-layer" @click="$emit('close')"></div>
    <div class="demo-search-data">
      <form class="search-form" @submit.stop.prevent="handleTabletSubmit()">
        <custom-input
          ref="searchinput"
          @input="onFilterChange(filter)"
          class="search-input"
          v-model.trim="filter"
          :inputType="'text'"
          :name="'dataSearchInput'"
          :label="searchPlaceholder"
          :placeholder="$t('search')"
          :autoComplete="'off'"
          :focusInputField="true"
        />
        <div class="input-icons">
          <div @click="onEraseFilter(filter)" v-if="filter.length" class="erase-wrapper">
            <i class="close-icon fa-light fa-times"></i>
          </div>
          <div v-show="searching">
            <i class="searching fa-light fa-circle-notch fa-spin"></i>
          </div>
          <div v-show="!searching" class="search-icon">
            <i class="fa-light fa-search"></i>
          </div>
        </div>
      </form>
      <ul class="result-list custom-scrollbar-light ellipsis">
        <li :class="{ 'is-selected': selectedDatasetId == null }" class="result-item" @click="onSelectResult(null)">
          {{ $t("tp-data-popover.sample") }}
        </li>

        <li
          v-for="result in resultList"
          :key="result.referenceName"
          :class="{ 'is-selected': result.id === selectedDatasetId }"
          class="result-item "
          :title="result.referenceName"
          @click="onSelectResult(result)"
        >
          <div class="title ellipsis">
            <span class="name">{{ result.referenceName }}</span>

            <span class="loading" v-show="result.id === selectedDatasetId && loading">
              <i class="fa-light fa-circle-notch fa-spin"></i>
            </span>
          </div>

          <div class="star-icon" @click.stop="toggleFavorite(result)">
            <icon-base
              :iconStroke="
                favoriteDatasets.some((favorite) => favorite.id === result.id) ? 'var(--flame)' : 'rgb(158, 167, 172)'
              "
              :iconColor="favoriteDatasets.some((favorite) => favorite.id === result.id) ? 'var(--flame)' : 'none'"
              width="14"
              height="14"
            >
              <icon-star />
            </icon-base>
          </div>

          <div class="variables-button" @click.stop="loadVariables(result)" :class="{'is-preview': previewDataSet && previewDataSet.id == result.id}">
              <i class="fa-light fa-chevron-right"></i>
          </div>

        </li>
        <span
          class="no-results text-small text-muted ellipsis"
          v-if="!searching && $store.state.templateDataSearchResults.length == 0 && filter.length"
        >
          {{ $t("tp-data-popover.no-result1") }} '{{ filter }}' {{ $t("tp-data-popover.no-result2") }}
        </span>
      </ul>
      <div v-if="variableGroups && !loadingVariablePreview && showVariablePreview " class="variable-list">
        <variable-selector
          class="list"
          :variable-groups="variableGroups"
          :show-values="true"
          :focusInputField="false"
          :showValueOnHover="true"
          :title="previewDataSet.referenceName"
        />
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import VariableGroup from "@/assets/js/variableGroup";
import VariableSelector from "@/components/VariableSelector";
import VariableHelpers from "@/assets/js/variableHelpers";
import IconBase from "@/components/icons/IconBase";
import IconStar from "@/components/icons/IconStar";
export default {
  components: {
    IconBase,
    IconStar,
    VariableSelector
  },
  data() {
    return {
      previewDataSet: null,
      showVariablePreview: false,
      loading: false,
      loadingVariablePreview: false,
      variables: null,
      selectedDatasetId: null,
      selectedDataset: null,
      filter: "",
      searching: false,
      onFilterChangeDebounce: debounce((filter) => {
        if (filter.length) this.search(filter).then(() => (this.searching = false), () => (this.searching = false));
        else {
          this.$store.state.templateDataSearchResults = [];
          this.searching = false;
        }
      }, 500)
    };
  },
  methods: {
    onEraseFilter(filter) {
      this.filter = "";
      this.onFilterChange("");
      this.$refs.searchinput.focus();
    },
    handleTabletSubmit() {
      if (this.$store.state.userDevice != "desktop") {
        this.$refs.searchinput.$el.children[0].blur();
      }
    },
    search() {
      return this.$store
        .dispatch("searchVariables", {
          filter: this.filter,
          templateId: this.$store.state.template.metadata.id
        })
        .then((results) => {
          this.searched = true;
          this.$store.state.templateDataSearchResults = results;
        });
    },
    onFilterChange(filter) {
      this.searching = true;
      this.onFilterChangeDebounce(filter);
    },
    onSelectResult(result) {
      this.selectedDatasetId = result ? result.id : null;
      this.selectedDataset = result;
      this.loading = true;
      this.$store
        .dispatch("getVariables", {
          template: this.$store.state.template.metadata,
          id: result ? result.id : null
        })
        .then((vars) => {
          this.loading = false;
          this.variables = vars;
          this.onSave();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    loadVariables(result){
      this.previewDataSet = result
      this.loadingVariablePreview = true
      this.$store
        .dispatch("getVariables", {
          template: this.$store.state.template.metadata,
          id: result ? result.id : null
        }).then((vars) => {
          this.variables = vars;
          this.showVariablePreview = true
          this.loadingVariablePreview = false;
        })
    },

    onSave() {
      this.$store.commit("setTemplateVariables", this.variables);
      this.$store.commit("setCurrentDatasetId", this.selectedDatasetId);
      this.$store
        .dispatch("getTemplatePreview", {
          template: this.$store.state.template,
          variables: this.$store.state.templateVariables,
        })
        .then((preview) => {
          console.log(this.selectedDataset);
          this.$store.commit("setTemplatePreview", preview);
          this.$store.commit("setSelectedDataset", { selectedDataset: this.selectedDataset });
          this.$store.dispatch("getTemplatePreviewForSectionType", "ai")
          this.$emit("close");
        });
    },
    toggleFavorite(result) {
      this.$store.dispatch("toggleFavorites", result);
    }
  },
  computed: {
    resultList() {
      return this.filter
        ? this.$store.state.templateDataSearchResults
        : this.favoriteDatasets.concat(
            this.$store.state.demoFavoriteList.filter((p) => !this.favoriteDatasets.map((p) => p.id).includes(p.id))
          );
    },
    favoriteDatasets() {
      return this.$store.state.dataFavorites;
    },
    searchPlaceholder() {
      if (
        this.$store.state.fixedConnectors
          .map((c) => c.value)
          .filter((c) => c !== "XmlFeed")
          .includes(this.$store.state.template.metadata.contentType.name)
      ) {
        return this.$t("tp-data-popover.product-search");
      } else {
        switch (this.$store.state.template.metadata.contentType.name) {
          case "SoccerMatch":
            return this.$t("tp-data-popover.soccer-search");
          case "CompanyResume":
            return this.$t("tp-data-popover.company-search");
          case "PersonResume":
            return this.$t("tp-data-popover.person-search");
          default:
            return this.$t("tp-data-popover.default-search");
        }
      }
    },
    variableGroups() {
      if (!this.selectedDatasetId && !this.variables) return this.$store.getters.variableGroups;
      if (!this.variables) return null;
      let combinedVars = [
        ...(this.variables || []),
        ...(this.$store.state.template.extraVariables.map((v) => ({
          custom: true,
          type: "Bool",
          ...v
        })) || [])
      ].reduce((vars, v) => {
        vars[v.name] = v;
        return vars;
      }, {});
      return new VariableGroup(VariableHelpers.groupVariables(combinedVars));
    }
  },
  mounted() {
    this.selectedDataset = this.$store.state.selectedDataset;
    this.selectedDatasetId = this.$store.state.currentDatasetId;
  }
};
</script>

<style lang="less">
.background-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
}
.demo-search-data {
  background: #fff;
  position: absolute;
  z-index: 99;
  top: 100%;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-radius: var(--standard-border-radius);
  min-width: 300px;
  max-width: 600px;
  .search-form {
    display: flex;
    align-items: center;
    position: relative;
    .search-input {
      padding: 0px 12px;
      flex-grow: 1;
      input {
        padding-right: 40px;
      }
    }
    .input-icons {
      display: flex;
      flex-direction: row;
      gap: 6px;
      position: absolute;
      right: 18px;
      bottom: 10px;
    }
  }
  .result-list {
    max-height: 400px;
    margin-top: 12px;
    padding: 0;
    width: auto;
    white-space: nowrap;
    overflow: auto;
    .result-item {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 6px 12px;
      cursor: pointer;

      .title {
        flex-grow: 1;
        display: flex;
        justify-content: space-between;
        gap: 12px;

        &:hover {
          .name {
            flex: 1 1 auto;
          }
          .loading {
            flex-grow: 1;
          }
        }
      }

      .star-icon {
        margin-top: 1px;
        svg {
          opacity: 1;
        }
      }
      &:hover {
        background-color: var(--alabaster);
      }

      &.is-selected {
        background-color: var(--alabaster);
      }
      .variables-button{
        padding: 0 6px;
        border-radius: 50% 50%;
        &:hover{
          
          background-color: #fff;
        }
        &.is-preview{
          background-color: var(--alabaster);
        }
      }
    }




 

    .no-results {
      text-align: center;
      padding: 6px 12px;
    }
    .fa-chevron-right {
      font-size: 12px;
    }
  }

  .variable-list{
    max-width: 300px;
    position: absolute;
    left: 100%;
    top: 0;
    background: #fff;
    position: absolute;
    z-index: 99;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
    border-radius: var(--standard-border-radius);
    padding: 12px 0;
    height: clamp(300px, 100%, 50vh);
    

    .variable-selector.list{
      position: relative;
      height: 100%;
      overflow: hidden;

      .variable-list-wrapper{
        max-height: calc(100% - 32px - 24px - 24px) ;
      }
    } 
  }
}
</style>
